import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Dashboard/Header";
import Footer from "../Dashboard/Footer";
import Notification from "../Notification/Notification";

function Layout() {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  return (
    <div className="flex flex-col min-h-screen relative">
      {/* Sticky Header */}
      <div className="sticky top-0 z-40">
        <Header
          isSideMenuOpen={isSideMenuOpen}
          setIsSideMenuOpen={setIsSideMenuOpen}
          isNotificationOpen={isNotificationOpen}
          setIsNotificationOpen={setIsNotificationOpen}
        />
      </div>

      <main
        className={`flex-grow transition-all duration-300 ease-in-out  ${
          isNotificationOpen ? "mr-96" : "mr-0"
        }`}
      >
        <Outlet />
      </main>

      {/* Notification Drawer */}
      {isNotificationOpen && (
        <Notification
          open={isNotificationOpen}
          onClose={() => setIsNotificationOpen(false)}
        />
      )}

      <Footer />
    </div>
  );
}

export default Layout;
